/**
 * Product catalogue categories.
 * Distinct from Engineering Service divisions.
 */

export const PRODUCT_CATEGORIES = [
  {
    id: "smart-electronics",
    name: "Smart Electronics",
    description:
      "Practical electronic and lighting products designed for industrial and commercial environments.",
  },
  {
    id: "industrial-solutions",
    name: "Industrial Solutions",
    description:
      "Automation, control and electrical products supporting plant engineering and operations.",
  },
  {
    id: "digital-platforms",
    name: "Digital Platforms",
    description:
      "Software and digital initiatives for industrial operations and engineering workflows.",
  },
  {
    id: "research-initiatives",
    name: "Research Initiatives",
    description:
      "Long-horizon research programmes exploring applied industrial intelligence and future systems.",
  },
];

export function getCategoryById(id) {
  return PRODUCT_CATEGORIES.find((c) => c.id === id) || null;
}

export function getCategoryName(id) {
  return getCategoryById(id)?.name || id;
}
